<template>
  <div v-infinite-scroll="uploadMoreTenders" class="tenders-wrapper">
    <DefaultErrorText v-if="tendersLoadingError" />
    <TenderCardSkeleton v-else-if="tendersLoading" />
    <div v-else-if="tenders && tenders.length" class="d-contents spacey-12">
      <TenderCard
        v-for="tender in tenders"
        :key="tender.id"
        :tender="tender"
        @update-tenders="(status) => localLoadTender({ status })"
      />
    </div>
    <div v-else class="d-contents">
      <ActiveTenderPlug v-if="tenderStatus === 'active'" @action="createTender" />
      <ArchivedTenderPlug v-else-if="tenderStatus === 'archived'" />
    </div>
  </div>
</template>

<script>
  import TenderCard from '@/components/tenders/tender-card/TenderCard';
  import TenderCardSkeleton from '@/skeletons/project/tenders/TenderCardSkeleton';
  import { mapActions, mapState } from 'vuex';
  import infiniteScroll from 'vue-infinite-scroll';
  import router from '@/router';
  import TENDER_STATUSES from '@/utils/constants/tender-statuses';
  import loadTenders from '@/utils/mixins/load-tenders';
  import ActiveTenderPlug from '@/components/tender/tender-list/ActiveTenderPlug';
  import ArchivedTenderPlug from '@/components/tender/tender-list/ArchivedTenderPlug';
  import createTender from '@/utils/mixins/create-tender';
  import DefaultErrorText from '@/components/ui/DefaultErrorText';

  export default {
    name: 'Tenders',
    components: {
      ArchivedTenderPlug,
      ActiveTenderPlug,
      TenderCardSkeleton,
      TenderCard,
      DefaultErrorText,
    },
    mixins: [createTender, loadTenders],
    directives: { infiniteScroll },
    data() {
      return {
        tenderStatus: router.currentRoute.params.status,
        TENDER_STATUSES,
      };
    },
    computed: {
      ...mapState('projectTenders', ['tenders', 'tendersLoading', 'tendersLoadingError']),
    },
    watch: {
      '$route.params.status': async function (status) {
        this.tenderStatus = status;
        await this.localLoadTender({ status: TENDER_STATUSES[status] });
      },
    },
    async mounted() {
      const status = TENDER_STATUSES[router.currentRoute.params.status];
      await this.localLoadTender({ status });
    },
    methods: {
      ...mapActions('projectTenders', ['uploadMoreTenders']),
    },
  };
</script>
